<template>
  <div>
    <main-layout>
      <v-tabs
        v-model="currentView"
        color="white"
        :slider-color="$vuetify.theme.primary"
        show-arrows
      >
        <v-tab ripple :key="'connectAccount'" :href="'#connectAccount'">
          {{ $t('connectAccount') }}
        </v-tab>

        <v-tab ripple :key="'customAudience'" :href="'#customAudience'">
          {{ $t('Custom Audience') }}
        </v-tab>

        <v-tab ripple :key="'HistoryAudience'" :href="'#HistoryAudience'">
          {{ $t('History Connect') }}
        </v-tab>
        <v-tab-item v-if="currentView == 'connectAccount'" :key="1" :value="'connectAccount'">
          <ConnectAccount />
        </v-tab-item>
        <v-tab-item v-if="currentView == 'customAudience'" :key="2" :value="'customAudience'">
          <customAudience />
        </v-tab-item>
        <v-tab-item v-if="currentView == 'HistoryAudience'" :key="3" :value="'HistoryAudience'">
          <HistoryAudience />
        </v-tab-item>
      </v-tabs>
    </main-layout>
    <template> </template>
  </div>
</template>

<script>
import ConnectAccount from './ConnectAccount.vue'
import customAudience from './CustomAudience.vue'
import HistoryAudience from './HistoryAudience.vue'
export default {
  data() {
    return {
      currentView: 'connectAccount'
    }
  },
  components: {
    ConnectAccount,
    customAudience,
    HistoryAudience
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/customAudience/Controller.vue